// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { SopMasterModel } from "src/app/model/SopMasterModel";

@Component({
  selector: "app-secure-board-list",
  templateUrl: "./sopMaster-list.component.html",
  styleUrls: ["./sopMaster-list.component.scss"],
})
export class SopMasterListComponent implements OnInit {
  page: Page<SopMasterModel>;
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  nonEditable: boolean;
  dataSourceLottery: MatTableDataSource<SopMasterModel> =
    new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "SopName",
    // "lotteryName",
    // "lotteryBoard",
    // "lotteryStage",
    "action",
  ];

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchSopMasterList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isSearchDisabled = false;
          if (data.status === "SUCCESS") {
            this.page = data.page;
            this.nonEditable = data.nonEditable;
            this.dataSourceLottery = new MatTableDataSource(this.page.content);
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = this.page.totalElements;
            });
          } else {
            this.nonEditable = true;
            this.masterService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
          this.nonEditable = true;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      // console.log("onSearch");
      // console.log(this.filterForm.valid);
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Lottery",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  editLottery(key: number) {
    // console.log("Edit Sop called ******** key for sop edit" + sopKey);
    this.router.navigate(["/secure", "sop-master", "au", key]);
  }

  deactivate(key: number) {
    if (confirm("Do you want to De-Activate the SOP Master")) {
      this.masterService.deactiveSop(key, "N").subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.onLoad();
          let selectedObj = this.page.content.find((o) => o.key === key);
          selectedObj.activeFlag = "N";
        } else {
          this.errorToast(data.errorMessage);
        }
      });
    }
  }

  generateSOPTemplate(key: string) {
    console.log(key);
    if (key) {
      this.masterService.downloadSopTemplate(key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            console.log(data);
            this.downloadFile(data.base64File, data.fileName);
          } else {
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorToast(
            error?.error?.message ||
              error?.errorMessage ||
              error?.error?.errorMessage
          );
        }
      );
    } else {
      this.masterService.errorToast("Please Select SOP");
    }
  }

  activate(key: number) {
    if (confirm("Do you want to Activate the SOP Master")) {
      console.log("Key for activate " + key);
      this.masterService.deactiveSop(key, "Y").subscribe((data: any) => {
        if (data.status === "SUCCESS") {
          this.onLoad();
          let selectedObj = this.page.content.find((o) => o.key === key);
          selectedObj.activeFlag = "Y";
        } else {
          this.errorToast(data.errorMessage);
        }
      });
    }
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
}
